<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="text-center pt-5">
          {{ $t("first-run.heading") }}
        </h1>
        <p class="lead pb-3 text-center" v-html="$t('first-run.text')"></p>
      </div>
    </div>
    <div class="row">
      <NewCompany></NewCompany>
      <ExistingCompany></ExistingCompany>
    </div>
  </div>
</template>

<script>
import NewCompany from '../components/first-run/new-company'
import ExistingCompany from '../components/first-run/existing-company'


export default {
    name: 'FirstRun',
    components: {
        NewCompany,
        ExistingCompany,
    },
    data: function() {
        return {
        }
    },
    methods: {
        sendInvite() {
            cm.verifyInviteCode(this.invite, response => {
                if (response.status === 200) {
                    this.$router.push('home')
                }
            })
        },
    },

}
</script>
